import { z } from "zod";
import { DynamicForm } from "../../util/DynamicForm";
import { useGeneratedForm } from "../../hooks/useGeneratedForm";
import { apiGet } from "../../util/axiosUtil";
import API_URL from "../../config/apiConfig";
import MutationHandler from "../../util/MutationHandler";

export default function Adjust({ onCancel, data, onSuccess }) {
  const startDate = data.startAt
    .toString()
    .replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
  const endDate = data.endAt
    .toString()
    .replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");

  const formConfig = {
    startAt: {
      label: "Start Date",
      type: "date",
      required: true,
      defaultValue: startDate,
      validation: z
        .string()
        .min(1, "Start Date is required")
        .refine((val) => !isNaN(Date.parse(val)), {
          message: "Start Date must be a valid date",
        }),
    },
    endAt: {
      label: "End Date",
      type: "date",
      required: true,
      defaultValue: endDate,
      validation: z
        .string()
        .min(1, "End Date is required")
        .refine((val) => !isNaN(Date.parse(val)), {
          message: "End Date must be a valid date",
        }),
    },
  };

  return (
    <MutationHandler
      mutationFn={(formData) => {
        const startAtLong = parseInt(formData.startAt.replace(/-/g, ""), 10); // "2025-05-14" -> 20250514
        const endAtLong = parseInt(formData.endAt.replace(/-/g, ""), 10); // "2025-05-16" -> 20250516

        return apiGet(
          `${API_URL}/api/subscribers/adjustment/${data.id}/${startAtLong}/${endAtLong}`
        );
      }}
      onCancel={onCancel}
      onSuccess={onSuccess}
    >
      {(mutation) => (
        <AdjustForm
          formConfig={formConfig}
          onSubmit={(value) => mutation.mutate(value)}
          isLoading={mutation.isPending}
          onCancel={onCancel}
        />
      )}
    </MutationHandler>
  );
}

function AdjustForm({ formConfig, onSubmit, isLoading, onCancel }) {
  const form = useGeneratedForm(formConfig, async ({ value }) => {
    onSubmit(value);
  });

  return (
    <DynamicForm
      form={form}
      formConfig={formConfig}
      isLoading={isLoading}
      onCancel={onCancel}
      buttonText={"Adjust"}
    />
  );
}
